export default "__VITE_ASSET__ezRHtABn__"